import React from "react";
import { useLocation } from "react-router-dom";

import { Layout, Descriptions } from "antd";
import dayjs from "dayjs";

var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
const { Content } = Layout;

// const table = "transactions"

const View = () => {
  const { state } = useLocation();

  console.log(state);

  return (
    <Content>
      {/* <Breadcrumb>
        <Breadcrumb.Item>Transaction</Breadcrumb.Item>
        <Breadcrumb.Item>Edit</Breadcrumb.Item>
      </Breadcrumb> */}
      <Descriptions title="Author Info" layout="vertical" bordered>
        <Descriptions.Item label="Name" span={3}>
          {state.fullName}
        </Descriptions.Item>
        <Descriptions.Item label="First Name">
          {state.firstName}
        </Descriptions.Item>
        <Descriptions.Item label="Last Name" span={2}>
          {state.lastName}
        </Descriptions.Item>
        <Descriptions.Item label="About" span={3}>
          {state.about}
        </Descriptions.Item>
        <Descriptions.Item label="Nationality" span={3}>
          {state.nationality}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {dayjs(state.createdAt).format("L LT")}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {dayjs(state.updatedAt).format("L LT")}
        </Descriptions.Item>
        {/* <Descriptions.Item label="Status" span={3}>
          <Tag color={tagColorByStatus(state.status)}>{state.status}</Tag>
        </Descriptions.Item> */}
      </Descriptions>
    </Content>
  );
};

export default View;
